import useApiMutation from 'shared/hooks/use-api-mutation';
import {OrderProps, OrderStatus} from '../types';
import useUpdateOrder from '../util/use-update-orders';

const useReadyToDelivery = (orderId: string) => {
  const updateOrder = useUpdateOrder();

  const onSuccess = (data: OrderProps) =>
    updateOrder(data, OrderStatus.ready_to_delivery);

  return useApiMutation({
    url: `/orders/${orderId}/ready-to-delivery`,
    method: 'PATCH',
    errorTitle: 'Erro ao alterar status do pedido',
    successTitle: 'Alteração de status do pedido',
    successMessage: 'Pedido em pronto aguardando entregador!',
    onSuccess,
  });
};

export default useReadyToDelivery;
